export default __webpack_public_path__ + "static/media/zine-avatar4.1bd37cf6.png";